import { KoobMapMarker } from '@koob/maps';

interface TripMapItineraryPoiMarkerProps {
  label?: string;
  poi?: {
    lat?: number | string | null;
    lon?: number | string | null;
    name?: string;
  };
  icon: string;
}

export default function TripMapItineraryPoiMarker({
  label,
  poi,
  icon,
}: TripMapItineraryPoiMarkerProps) {
  return (
    <KoobMapMarker
      lat={poi?.lat ?? ''}
      lng={poi?.lon ?? ''}
      label={label}
      icon={icon}
      title={poi?.name}
      popup={<p className="py-3 pl-3 pr-10">{poi?.name}</p>}
    />
  );
}
